import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';
import { queryClient } from '../../queryClient';

interface HookProps {
  batchId: string;
  fileName: string;
}

export const useGenerateBatchRiskAnalysisReport = () => {
  return useMutation({
    mutationFn: async ({ batchId }: HookProps) => {
      const result = await apiClient.batchesReports.generateRiskAnalysisReport.mutation({ body: { batchId } });
      if (result.status !== 200) throw result.body;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['getUserReports'] });
      toast.success('The report is being generated.');
    },
    onError: (error) => {
      showErrorToast(error, 'Error generating the report!');
    },
  });
};
